import React from 'react'

export const Alarm = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_6004)'>
      <path
        d='M12 22.0001C10.8181 22.0001 9.64778 21.7673 8.55585 21.315C7.46392 20.8627 6.47177 20.1998 5.63604 19.364C4.80031 18.5283 4.13738 17.5362 3.68509 16.4442C3.23279 15.3523 3 14.182 3 13.0001C3 11.8182 3.23279 10.6479 3.68509 9.55592C4.13738 8.46399 4.80031 7.47184 5.63604 6.63611C6.47177 5.80038 7.46392 5.13745 8.55585 4.68515C9.64778 4.23286 10.8181 4.00007 12 4.00007C14.387 4.00007 16.6761 4.94828 18.364 6.63611C20.0518 8.32394 21 10.6131 21 13.0001C21 15.387 20.0518 17.6762 18.364 19.364C16.6761 21.0519 14.387 22.0001 12 22.0001ZM13 13.0001V8.00007H11V15.0001H16V13.0001H13ZM1.747 6.28207L5.282 2.74707L6.697 4.16107L3.16 7.69707L1.747 6.28207ZM18.717 2.74707L22.253 6.28207L20.839 7.69707L17.303 4.16107L18.718 2.74707H18.717Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_6004'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
